import { UpdateUserPayload, UserResponse } from '@dark-portal/backend-planora';
import { RequestResponse } from '@dark-portal/react-infrastructure';

import { Requester } from '@/src/features/api/_infrastructure/requester';

export const UsersApi = {
  getMe: (): RequestResponse<UserResponse> => Requester.get('planora/users/me'),

  update: (body: UpdateUserPayload): RequestResponse<UserResponse> => Requester.patch('planora/users/me', body),
  register: (body: UpdateUserPayload): RequestResponse<UserResponse> => Requester.post('planora/users/me', body),
};
